module.exports = __webpack_public_path__ + "img/brandstory_top.a79c7edd.png";